import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getLands(options={}) {
	return _apiRequestWrap(
		ModulesMap.LANDS,
		ModulesConfigMap[ModulesMap.LANDS].GET_LANDS,
		options
	)
}

function _getLand(options={}) {
	return _apiRequestWrap(
		ModulesMap.LANDS,
		ModulesConfigMap[ModulesMap.LANDS].GET_LAND,
		options
	)
}

function _createLand(options={}) {
	return _apiRequestWrap(
		ModulesMap.LANDS,
		ModulesConfigMap[ModulesMap.LANDS].CREATE_LAND,
		options
	)
}

function _putLand(options={}) {
	return _apiRequestWrap(
		ModulesMap.LANDS,
		ModulesConfigMap[ModulesMap.LANDS].PUT_LAND,
		options
	)
}

function _patchLand(options={}) {
	return _apiRequestWrap(
		ModulesMap.LANDS,
		ModulesConfigMap[ModulesMap.LANDS].PATCH_LAND,
		options
	)
}

function _deleteLand(options={}) {
	return _apiRequestWrap(
		ModulesMap.LANDS,
		ModulesConfigMap[ModulesMap.LANDS].DELETE_LAND,
		options
	)
}

function _getLandPreview(options={}) {
	return _apiRequestWrap(
		ModulesMap.LANDS,
		ModulesConfigMap[ModulesMap.LANDS].GET_LAND_PREVIEW,
		options
	)
}

function _getLandPopup(options={}) {
	return _apiRequestWrap(
		ModulesMap.LANDS,
		ModulesConfigMap[ModulesMap.LANDS].GET_LAND_POPUP,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.LANDS].GET_LANDS]: _getLands,

	[ModulesConfigMap[ModulesMap.LANDS].GET_LAND]: _getLand,
	[ModulesConfigMap[ModulesMap.LANDS].GET_LAND_PREVIEW]: _getLandPreview,
	[ModulesConfigMap[ModulesMap.LANDS].GET_LAND_POPUP]: _getLandPopup,

	[ModulesConfigMap[ModulesMap.LANDS].CREATE_LAND]: _createLand,
	[ModulesConfigMap[ModulesMap.LANDS].PUT_LAND]: _putLand,
	[ModulesConfigMap[ModulesMap.LANDS].PATCH_LAND]: _patchLand,
	[ModulesConfigMap[ModulesMap.LANDS].DELETE_LAND]: _deleteLand,
}